<template>
  <v-card elevation="0" tile outlined class="pa-0 d-flex flex-column">
    <!-- :loading="loading" -->
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <div v-if="data.images && data.images.length > 0">
      <CarouselImages :items="data.images"></CarouselImages>
    </div>

    <v-card-title>{{ data.nombre }}</v-card-title>

    <v-card-text>
      <div class="subtitle-1">
        {{ data.descripcion }}
      </div>

      <div>{{ data.tecnologias }}</div>
    </v-card-text>

    <v-spacer></v-spacer>
    <v-divider></v-divider>

    <v-card-actions class="d-flex justify-end">
      <v-btn
        color="primary"
        class="caption"
        small
        text
        @click="to('showProyect', { id: data.id })"
      >
        Detalles
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CarouselImages from './CarouselImages.vue'

export default {
  components: { CarouselImages },
  props: {
    data: Object,
    index: Number,
    disableActions: Boolean
  },
  data() {
    return {
      cantidad: 1
    }
  },
  computed: {
    categoriaText() {
      return this.data.categoria
    }
  },
  methods: {
    to(name, params) {
      // console.log('to -> name', name)
      this.$router.push({ name, params })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .product-link {
    color: $vue-color;
  }

  .delete-btn {
    cursor: pointer;
    padding: 5px 10px;
    border: 1px solid;
    display: inline-block;
    border-radius: 3px;
    margin-left: 10px;
    color: $danger-color;
    border-color: $danger-color;
  }
}

.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 5px; /* 5px rounded corners */
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}

img {
  border-radius: 5px 5px 0 0;
}
</style>
